import withHoliday from './withHoliday';

export { withHoliday };
